import Vue from 'vue';
import App from './App.vue';
import router from './router';
import './assets/base.css';
import './utils/rem';
import toast from '@/components/message/Toast';
import './utils/point';

Vue.config.productionTip = false;
import VueFungoLogin from 'vue-fungo-login';
import '../node_modules/vue-fungo-login/lib/login.css';
import VueI18n from 'vue-i18n';
Vue.use(VueFungoLogin).use(VueI18n);
Vue.prototype.$toast = toast;

if (document.documentElement.offsetWidth <= 1100) {
	Vue.prototype.$isH5 = true;
}

const i18n = new VueI18n({
	// locale:sessionStorage.getItem('lang')?sessionStorage.getItem('lang'):'zh', // 语言标识
	locale: sessionStorage.getItem('lang')
		? sessionStorage.getItem('lang')
		: 'cn',
	messages: {
		tw: require('./assets/lang/zh-tw'),
		en: require('./assets/lang/en-us'),
		kr: require('./assets/lang/ko-kr'),
		jp: require('./assets/lang/ja-jp'),
		cn: require('./assets/lang/zh-cn'),
		th: require('./assets/lang/th-th'),
	},
});
new Vue({
	router,
	i18n,
	render: (h) => h(App),
}).$mount('#app');
import '@/utils/env';
